import { useState } from 'react';
import './../pages/Auth.css';

const STORAGE_KEY = 'yesnedni-demo-gate-unlocked';

// Verrou applicatif côté frontend — actif uniquement si une vraie valeur est
// fournie via REACT_APP_DEMO_GATE_PASSWORD (Netlify → Environment variables).
// Portable : aucune dépendance à une fonctionnalité propriétaire d'hébergeur,
// fonctionne identiquement sur Netlify, CERIST ou tout autre serveur statique.
function isGateConfigured() {
  const pwd = process.env.REACT_APP_DEMO_GATE_PASSWORD;
  return Boolean(pwd) && !pwd.startsWith('CHANGE_ME');
}

export default function DemoGate({ children }) {
  const [unlocked, setUnlocked] = useState(
    () => !isGateConfigured() || sessionStorage.getItem(STORAGE_KEY) === 'true'
  );
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  if (unlocked) {
    return children;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value === process.env.REACT_APP_DEMO_GATE_PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      setUnlocked(true);
    } else {
      setError('Mot de passe incorrect.');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div className="auth-logo">
          <img src={`${process.env.PUBLIC_URL}/logo/ynd-primary-gold-navy.jpg`} alt="" />
          <span className="auth-logo-text">YesNeDni</span>
        </div>
        <h1>Accès réservé</h1>
        <p className="auth-sub">
          Plateforme en cours de présentation au jury — entrez le mot de passe communiqué pour continuer.
        </p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <label>Mot de passe d'accès</label>
          <input
            type="password" required autoFocus
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Mot de passe"
          />
          <button type="submit" className="auth-btn">Accéder</button>
        </form>
      </div>
    </div>
  );
}
